import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getUsersTemplateAPI() {
  const url = `${AWS_API_URL}/assets/users-template`;
  return getRequest(url, await authorize());
}
